<template>
  <div class="imageSlider">
    <div class="slider">
      <button class="leftArrow" @click="prev"><img src="../assets/btn_arrow_left_dark.jpg"/></button> 
      <div class="imgFlex">
        <img class="imageslides" style="display:block" src="../assets/appscrn_1.jpg"/>
        <img class="imageslides" style="display:none" src="../assets/appscrn_2_avatar.png"/>
        <img class="imageslides" style="display:none" src="../assets/appscrn_3_coins.png"/>
        <img class="imageslides" style="display:none" src="../assets/appscrn_4_chat.png"/>
        <img class="imageslides" style="display:none" src="../assets/appscrn_5_meet.png"/>
      </div>
      <button class="rightArrow" @click="next"><img src="../assets/btn_arrow_right_dark.jpg"/></button>
    </div>
    <div class="slideTextDiv">
      <h2 id="imageslideTitle">Easy-to-use intuitive sign-up</h2>
      <p id="slideText">With users of a large variance in diagnosis and severity,we created an extremely minimal sign up process.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "imageSlider",
  data:function() {
    return{
        imagetitles:['Easy-to-use intuitive sign-up ','Create your own avatar ','Earn coins by using our app ','Interact with people all over the world ','Schedule in-person meetups '],
        text:['With users of a large variance in diagnosis and severity, we created an extremely minimal sign up process.',
        'With hundreds of combinations, you can create an avatar in your likeness, or just make a fun cartoon.',
        'Signing in daily, or simply interacting with others earns you coins. Spend your coins on cool hats or advanced features.',
        'An easy-to-use map interface shows the people that are closest to you.<br> Chat with them freely or through using our predictive text engine.',
        'We look at your shared interests and offer up the best optionsnearest to your location. Set a date and have some fun!'],
        currentNumber: 0,
    }
    },

    methods: {
        next: function() {
            this.currentNumber += 1;
            this.hideSlides();
        },
        prev: function() {
            this.currentNumber -= 1;
            this.hideSlides();
        },
        hideSlides:function(){
            var imageSlidesArray=document.getElementsByClassName('imageslides');
            var imgSlideLen=imageSlidesArray.length;
            var visible=Math.abs(this.currentNumber) % imgSlideLen;
            for (var i=0;i<imgSlideLen;i++){
              imageSlidesArray[i].style.display="none";
            }
            imageSlidesArray[visible].style.display="block";
            document.getElementById("imageslideTitle").innerHTML = this.imagetitles[visible];
            document.getElementById("slideText").innerHTML = this.text[visible];
        }
    },
}
</script>

<style scoped>
@import "../../assets/style.css";
.imageslides {
  width: 978.984px;
  margin: 0;
}

.imgFlex {
  align-content: center;
  align-self: center;
}

#imageslideTitle {
  font-size: 42px;
  color:#F06377;
  align-self: center;
  align-content: center;
  width: 70%;
  margin-left: 15%;
  font-family: 'chunk';
  font-weight: inherit;
  
}
#slideText {
  font-size: 25px;
  align-self: center;
  align-content: center;
  width: 70%;
  margin-left: 15%;
  font-family: 'futura';
  font-weight: normal;
  letter-spacing: .5px;

}
.leftArrow {
  background:none;
  outline:none;
  border:none;
  cursor: pointer;
  margin-right:10%;
}
.rightArrow {
  background: none;
  outline: none;
  border: none;
  cursor: pointer;
  margin-left: 10%;
}
.imageSlider {
  display: flex;
  flex-direction: column;
}
.slider {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 70%;
  margin-left: 15%;
}
@media screen and (max-width:767px) {
  .slideTextDiv {
    width: 100%;
    align-content: center;
    align-items: center;

  }
  #slideText{
    font-size: 16px;
    width: 80%;
    margin-left: 10%;
    
  }
  #imageslideTitle{
    font-size: 20px;
    width: 80%;
    margin-left: 10%;
  }
  .imageslides{
    width: 80vw;
  }
  .leftArrow{
    margin-right: 0 !important;
  }
  .leftArrow img{
        height: 50px !important;
        margin-right: 0px;
        margin-top: 20px;
    }
  .rightArrow{
    margin-left: 0!important;
  }
  .rightArrow img{
    height: 50px !important;
    margin-left: 0px;
    margin-top: 20px;
  }
  #slideTitle{
    font-size: 2vmax;
  }
}
@media screen and (max-width:767px) and (orientation:landscape){
  .imageslides {
    width: 425px;
  }
  .rightArrow {
    margin:0;
  }
  .rightArrow img {
    height: 70px !important;
    margin-left: 0px;
  }
  .leftArrow {
    margin: 0;
  }
  .leftArrow img {
    height:70px !important;
    margin-right: 0px;
  }
    
}
@media screen and (min-width:768px) and (max-width:1024px) {
  .imageslides {
    width: 600px;
  }
  .leftArrow img{
    height: 70px !important;
    margin-right: 0px;
  }
  .leftArrow {
    margin: 0;
  }
  .rightArrow {
    margin: 0;
  }
  .rightArrow img{
    height: 70px !important;
    margin-left: 0px;
  }
}

  

</style>